export default [
  { value: 'COMPANY', label: 'Company' },
  { value: 'MLS', label: 'MLS' },
  { value: 'NORD', label: 'Nord' },
];
